<div class="app-container">
  <router-outlet />
</div>

@if (hasUpdateAvailable()) {
  <div class="version-update-toast" role="status" aria-live="polite">
    New version available ({{ buildVersion }}). Reloading...
  </div>
}
